<template>
  <v-row class="mr-4" no-gutters align="center">
    <v-col class="text-right" cols="8">
      <div class="font-weight-bold caption line-padding" v-text="label"/>
    </v-col>
    <v-col class="text-right">
      <div class="subtitle-2" v-if="text === ''">
        £{{(value / 100).toFixed(2)}}
      </div>
      <div class="subtitle-2" v-else v-text="text"/>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "Bill",
    props: {
      label: {
        type: String,
        default: ""
      },
      value: {
        type: Number,
        default: 0
      },
      text: {
        type: String,
        default: ""
      }
    }
  }
</script>

<style scoped>
  .line-padding {
    padding: 0px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Bill.vue